import { render, staticRenderFns } from "./ViewContactActivity.vue?vue&type=template&id=a3a53e46&"
import script from "./ViewContactActivity.vue?vue&type=script&lang=js&"
export * from "./ViewContactActivity.vue?vue&type=script&lang=js&"
import style0 from "./ViewContactActivity.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports